import React from "react";
import { Link } from "react-router-dom";
import { Send } from "lucide-react";
import logo from "@/assets/logo.png";
import { SOCIALS, XIcon } from "@/lib/socials";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-16 bg-black/30" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-8">
          <div className="max-w-sm">
            <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
              <img src={logo} alt="SuiPads" className="w-9 h-9 rounded-xl object-contain" />
              <span className="font-display font-extrabold text-lg tracking-tight brand-gradient">SuiPads</span>
            </Link>
            <p className="text-sm text-muted-foreground mt-3">
              Fair-launch memecoins on Sui. Bonding curve → auto-migrate to Cetus at 7,500 SUI. 1% fee (0.7% dev / 0.3% platform), enforced on-chain.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href={SOCIALS.x} target="_blank" rel="noreferrer" data-testid="footer-x" aria-label="X" className="p-2.5 rounded-xl bg-white/5 border border-white/10 text-muted-foreground hover:text-[#1EC62E] hover:border-[#1EC62E]/40 transition-colors"><XIcon className="w-4 h-4" /></a>
              <a href={SOCIALS.telegram} target="_blank" rel="noreferrer" data-testid="footer-telegram" aria-label="Telegram" className="p-2.5 rounded-xl bg-white/5 border border-white/10 text-muted-foreground hover:text-[#1EC62E] hover:border-[#1EC62E]/40 transition-colors"><Send className="w-4 h-4" /></a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:gap-16">
            <div>
              <div className="text-[11px] uppercase tracking-[0.15em] text-muted-foreground font-bold mb-3">Platform</div>
              <div className="flex flex-col gap-2 text-sm">
                <Link to="/" className="text-muted-foreground hover:text-white transition-colors" data-testid="footer-nav-board">Board</Link>
                <Link to="/portfolio" className="text-muted-foreground hover:text-white transition-colors" data-testid="footer-nav-portfolio">Portfolio</Link>
                <Link to="/vesting" className="text-muted-foreground hover:text-white transition-colors" data-testid="footer-nav-vesting">Vesting</Link>
              </div>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.15em] text-muted-foreground font-bold mb-3">Resources</div>
              <div className="flex flex-col gap-2 text-sm">
                <Link to="/how-it-works" className="text-muted-foreground hover:text-white transition-colors" data-testid="footer-nav-how">How it Works</Link>
                <Link to="/whitepaper" className="text-muted-foreground hover:text-white transition-colors" data-testid="footer-nav-whitepaper">Whitepaper</Link>
                <a href={SOCIALS.x} target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-white transition-colors">X (Twitter)</a>
                <a href={SOCIALS.telegram} target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-white transition-colors">Telegram</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} SuiPads. Live on Sui mainnet.</span>
          <span>Memecoins are high-risk. Trade responsibly — nothing here is financial advice.</span>
        </div>
      </div>
    </footer>
  );
}
